import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet, axiosDelete } from "./axiosFunctions";

const getMatMasterAllUrl                = '/api/admin/mat/getMatMasterAll';
const postMatMasterUrl                  = '/api/admin/mat/postMatMaster';

const getMatTimeMasterAllUrl            = '/api/admin/mat/getMatTimeMasterAll';
const postMatTimeMasterUrl              = '/api/admin/mat/postMatTimeMaster';

const postMatTemplateUrl                = '/api/admin/mat/postMatTemplate';
const getMatTemplateByMasterIDUrl       = (id) => `/api/admin/mat/getMatTemplateByMasterID/${id}`;
const deleteMatTemplateUrl              = '/api/admin/mat/deleteMatTemplate';

const getMatBookUrl                     = '/api/admin/mat/getMatBook';
const postMatTimeBlockUrl               = '/api/admin/mat/postMatTimeBlock';  
const postMatBookUrl                    = '/api/admin/mat/postMatBook';  
const deleteMatTimeBlockUrl             = (id) => `/api/admin/mat/deleteMatTimeBlock/${id}`;  
const deleteMatBookUrl                  = (matBookID) => `/api/admin/mat/deleteMatBook/${matBookID}`;  
const getMatCancellationSheetUrl        = (fDate, tDate) => `/api/admin/mat/getMatCancellationSheet/${fDate}/${tDate}`;

const getMatPublishPageDataUrl          = '/api/admin/mat/getMatPublishPageData';    
const postMatPublishUrl                 = '/api/admin/mat/postMatPublish';    
const getPublishMasterDataUrl           = '/api/admin/mat/getPublishMasterData';    


//RANGE FEE 
const getGreenFeeCalendarAllUrl                   =         '/api/admin/mat/getRangeFeeCalendarAll';
const postRangeFeeCalendarUrl                     =         '/api/admin/mat/postRangeFeeCalendar';
const getRangeFeeMasterByCalenderIDUrl            = (calendarID) => `/api/admin/mat/getRangeFeeMasterByCalenderID/${calendarID}`;
const postRangeFeeMasterUrl                       = '/api/admin/mat/postRangeFeeMaster';
const getActiveGuestsUrl                          = '/api/admin/mat/getActiveGuests';
const getActiveRangeFeeMasterUrl                  = (currentDate) => `/api/admin/mat/getActiveRangeFeeMaster/${currentDate}`;
const getBucketsUrl                               = '/api/admin/mat/getBuckets';
const getUserTypesUrl                             = '/api/admin/mat/getUserTypes';
const postMatBookOfflineUrl                       = '/api/admin/mat/postMatBookOffline';


export const deleteMatBook = async (matBookID) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        deleteMatBookUrl(matBookID),
       { headers: '' }
    );
    return response;
};

export const getMatCancellationSheet = async (fDate, tDate) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getMatCancellationSheetUrl(fDate, tDate),
       { headers: '' }
    );
    return response;
};

export const getMatMasterAll = async() => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatMasterAllUrl,  { headers: '' } );
    return response;
}

export const postMatMaster= async(matMaster)=>{
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatMasterUrl, { matMaster },  { headers: '' } );
    return response;
}

export const getMatTimeMasterAll = async() => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatTimeMasterAllUrl,  { headers: '' } );
    return response;
}

export const postTimeMatMaster= async(matMaster)=>{
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTimeMasterUrl, { matMaster },  { headers: '' } );
    return response;
}

export const postMatTemplate= async(matTemplate)=>{
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTemplateUrl, { matTemplate },  { headers: '' } );
    return response;
}

export const deleteMatTemplate = async(templateId) => {
    // const token = getAuthState('token');
    // if(!token) setTimeout(() => { return }, 2000);

    const response = await axiosDelete( `${deleteMatTemplateUrl}/${templateId}`,  { headers: '' });
    return response;
}

export const getMatTemplateByMasterID = async(id) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatTemplateByMasterIDUrl(id),  { headers: '' } );
    return response;
}

export const getMatBook = async (matBookDetails) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( getMatBookUrl, {matBookDetails},  { headers: '' } );
    return response;
}

export const postMatTimeBlock = async(books, date) =>{
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTimeBlockUrl, { books, date },  { headers: '' } );
    return response;
}

export const deleteMatTimeBlock = async (id) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteMatTimeBlockUrl(id),
       { headers: '' }
    );
    return response;
};

export const postMatBook = async(matBook)=>{
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatBookUrl, { matBook },  { headers: '' } );
    return response;
}

export const getMatPublishPageData = async() => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatPublishPageDataUrl,  { headers: '' } );
    return response;
}

export const postMatPublish = async(data) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatPublishUrl, {...data },  { headers: '' } );
    return response;
}

export const getPublishMasterData = async(masterId) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( `${getPublishMasterDataUrl}/${masterId}`,  { headers: '' } );
    return response;
}


export const getRangeFeeCalendarAll = async () => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getGreenFeeCalendarAllUrl, { headers:'' } );
    return response;
}

export const postRangeFeeCalendar = async (calendar) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postRangeFeeCalendarUrl, { calendar } , { headers: '' } );
    return response;
}

export const getRangeFeeMasterByCalenderID = async (calendarID) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getRangeFeeMasterByCalenderIDUrl(calendarID), { headers: '' } );
    return response;
};

export const postRangeFeeMaster = async (rangeFeeMasterList) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(
        postRangeFeeMasterUrl,
      { rangeFeeMasterList },
      { headers: '' }
    );
    return response;
};

export const getActiveGuests = async () => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getActiveGuestsUrl, { headers: '' } );
    return response;
};

export const getActiveRangeFeeMaster = async (currentDate) => {
    const response = await axiosGet( getActiveRangeFeeMasterUrl(currentDate), { headers: '' } );
    return response;
};

export const getBuckets = async () => {  
    const response = await axiosGet( getBucketsUrl, { headers: '' } );
    return response;
};

export const getUserTypes = async () => { 
    const response = await axiosGet( getUserTypesUrl, { headers: '' } );
    return response;
};

export const postMatBookOffline = async(matBook)=>{
    const response = await axiosPost( postMatBookOfflineUrl, { matBook }, { headers: '' } );
    return response;
}
